





























import {Component, Prop, Vue, Watch} from 'vue-property-decorator'
import {uniqueId} from "@/util/uniqueId";

@Component
export default class ToggleInput extends Vue {

    @Prop({
        default: null
    })
    tooltip?: string | null;

    @Prop()
    name?: string;

    @Prop()
    label!: string;

    @Prop()
    value!: boolean | null;

    private innerValue: boolean | null = this.value === null ? null : this.value;

    @Watch('innerValue')
    private onInnerValueUpdated() {
        this.$emit('input', this.innerValue);
    }
}
